/* eslint-disable react/no-unescaped-entities */
import DocPageLayout, { Section } from "@/components/DocPageLayout";

const ROADMAP = {
  next: [
    "Email notifications via Resend — PO validations, PO completions, tier promotions, dispute updates.",
    "Admin 'Clear Strike' controls — per-user row action to reverse strikes with an audit note.",
    "Team-name data cleanup — 'Chiefs' → 'Kansas City Chiefs' migration so team filter is bulletproof.",
    "Bulk-edit dialog polish — shadcn AlertDialog for empty-apply and delete confirmations.",
  ],
  soon: [
    "Mobile notification bell moved to bottom tab bar for one-thumb reach.",
    "Backend refactor of api_listings.py (850+ lines) into modular files — no user-facing change.",
    "Admin Support Tickets tab wired to the /contact form submissions.",
    "Public seller feedback wall on /u/USERNAME — showcase Excellent-rated recent sales.",
  ],
  later: [
    "AI-assisted card listing / OCR — upload a photo, AI extracts player/year/set/parallel/grade/cert# using vision LLM. Seller confirms and publishes in seconds.",
    "Trending Fan Favorites — sort by like-velocity (last 24h growth), not total likes, so hot new drops surface.",
    "Bulk shipping label generator with combined-shipping math built in.",
    "Vendor 'Vacation Mode' toggle — auto-holds all your active listings until you return.",
    "Deals Under $25 featured section for budget browsers.",
  ],
  wishlist: [
    "In-app group breaking / lot sales.",
    "PSA / SGC API integration to auto-verify slabbed cards.",
    "Native mobile app (React Native).",
    "Referral commission program for high-volume vendors.",
  ],
};

const priorityStyle = {
  next: { color: "text-emerald-400", label: "→ Now / Next" },
  soon: { color: "text-[#FFD700]", label: "→ Coming Soon" },
  later: { color: "text-[#FF5F1F]", label: "→ Later" },
  wishlist: { color: "text-[#007AFF]", label: "→ Wishlist" },
};

export default function Roadmap() {
  return (
    <DocPageLayout
      subtitle="Public Board"
      title="Roadmap"
      intro="What's actively being built, what's queued, and what's on the wishlist. Priorities can shift based on community feedback — hit /contact if there's something you'd love to see."
    >
      {Object.entries(ROADMAP).map(([key, items]) => {
        const meta = priorityStyle[key];
        return (
          <section key={key} data-testid={`roadmap-${key}`}>
            <h2 className={`font-display font-black uppercase text-lg tracking-tight ${meta.color} mb-2`}>
              {meta.label}
            </h2>
            <ul className="list-disc pl-5 space-y-1 text-[14px] leading-relaxed text-zinc-300">
              {items.map((it, i) => <li key={i}>{it}</li>)}
            </ul>
          </section>
        );
      })}

      <Section title="How we prioritize">
        <p>Bugs affecting active vendors ship first. Community-requested features that touch trust (reports, strikes, feedback) are next. Nice-to-haves get slotted based on effort vs impact. If something you care about isn't listed, file a technical Support ticket and mention "feature request" — it goes into the same queue admins review.</p>
      </Section>
    </DocPageLayout>
  );
}
